import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowLeftOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m5.446 12.9 6.827 6.827L11 21l-9-9 9-9 1.273 1.273L5.446 11.1H22v1.8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowLeftOutlinedSize24Glyph.displayName = 'ArrowLeftOutlinedSize24Glyph';
